// src/client/task-types/mf/svg-css-challenge.js

const {requestAce, requestMultifileTask} = require('../base');

const mfSvgCssChallengeModules = {
  create({assetsPath, aceWorkerPath}) {
    return [
      requestAce({
        assetsPath,
        aceWorkerPath,
        modes: ['svg', 'css']
      }),
      requestMultifileTask(),
      import('client/views/multifile-top/svg-css-challenge-view'),
      import('client/runners/svg-css-runner'),
      import('client/checkers/svg-css-challenge-checker')
    ];
  },
  componentNames: [
    'HtmlCssChallengeView',
    'SvgCssRunner',
    'SvgCssChallengeChecker'
  ]
};

module.exports = {
  mfSvgCssChallengeModules,
};
